<template>
  <l-layout :layout="['xs12']">
    <v-card class="pa-3">
      <v-card-title>
        <v-layout column>
          <span class="title">教工进校申请</span>
          <span style="font-size: 16px;color: red" class="mt-2">【温馨提示】</span>
          <span style="font-size: 16px;color: red" class="mt-1">您的进校申请须由本单位负责人审批，相关业务部门审核。申请时，请确认您自申请当日起的过往14天符合进校健康条件。申请成功，且进校当日符合进校健康条件，方可入校。办理完相关事宜后请即离开，不要在校园内逗留，感谢您的配合！</span>
        </v-layout>
      </v-card-title>
      <v-form ref="form" v-if="importList.length==0">
        <v-layout column>
          <v-layout>
            <v-flex xs12>
              <v-text-field label="计划进校时间" prepend-icon="$vuetify.icons.date" v-model="form.stTime" disabled></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-select label="进校事由类别" prepend-icon="$vuetify.icons.code" v-model="form.reviewType" :items="select"
                        item-text="label" item-value="value"></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-textarea label="进校事由详述" prepend-icon="$vuetify.icons.comment" v-model="form.comment" :rules="[$rules.requiredS(),$rules.requireCounter(160)]"
                          :disabled="disabledFlag" rows="1" auto-grow></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-text-field label="校内办公地点（请注明校区）" prepend-icon="$vuetify.icons.location" v-model="form.referPlace" :rules="[$rules.requiredS()]"
                            :disabled="disabledFlag"></v-text-field>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-form>
      <l-data-table
        :items="importList"
        :headers="header"
        v-show="importList.length>0"
        hide-title
        hide-title-search></l-data-table>
      <v-layout justify-end>
        <v-btn class="primary" @click="goApplyList"  small>申请历史</v-btn>
        <v-btn class="primary" @click="importList.length>0?importTeacherSubmit():confirm()" :disabled="disabledFlag" :loading="loading" small>提交</v-btn>
      </v-layout>
    </v-card>
    <v-card class="mt-4 pl-2" v-if="hasFirstReviewPermission||hasSecondReviewPermission">
      <v-card-title>
        <span class="title">
          管理员审批
        </span>
      </v-card-title>
      <v-layout  v-if="hasFirstReviewPermission">
        <v-flex xs8 class="pl-3 pt-2">
          <v-layout class="mb-1">
            <span class="mr-1">
              <v-icon>{{$vuetify.icons.group}}</v-icon>
             </span>
            <p style="font-size: 17px">二级单位审核</p>
          </v-layout>
        </v-flex>
        <v-flex xs4 class="mr-2">
          <v-btn class="primary" @click="goFirstReviewList" small>查看审核列表</v-btn>
        </v-flex>
      </v-layout>
      <v-layout  v-if="hasSecondReviewPermission">
        <v-flex xs8 class="pl-3 pt-2">
          <v-layout class="mb-2">
            <span class="mr-1">
              <v-icon>{{$vuetify.icons.group}}</v-icon>
             </span>
            <p style="font-size: 17px">业务部门审核</p>
          </v-layout>
        </v-flex>
        <v-flex xs4 class="mr-2">
          <v-btn color="primary" @click="goSecondReviewList" small>查看审核列表</v-btn>
        </v-flex>
      </v-layout>
    </v-card>
    <v-dialog v-model="confirmDialog.activated" width="500">
      <v-layout column>
        <v-card class="pa-3">
          <v-card-title>
            <span class="title">申请确认</span>
          </v-card-title>
          <v-layout class="pl-3" column style="font-size: 18px">
            <v-flex xs12>
              <span>您计划于</span>
              <span>{{form.stTime}}</span>
              <span>进入</span>
              <span>校园</span>
            </v-flex>
          </v-layout>
          <v-layout class="pl-3" column style="font-size: 18px">
            <v-flex xs12>
              <span>办公地点：</span>
              <span>{{form.referPlace}}</span>
            </v-flex>
          </v-layout>
          <v-layout class="pl-3" column style="font-size: 18px">
            <v-flex xs12>
              <span>进校事由：</span>
              <span>{{form.comment}}</span>
            </v-flex>
          </v-layout>
          <v-layout justify-center>
            <v-btn class="primary" @click="submit" :loading="loading" :disabled="disabledFlag">确认</v-btn>
            <v-btn class="error" @click="confirmDialog.activated=false" :disabled="disabledFlag">取消</v-btn>
          </v-layout>
        </v-card>
      </v-layout>
    </v-dialog>
    <v-dialog max-width="1000px" persistent scrollable v-model="importErrorDialog.activate">
      <v-card>
        <v-card-title style="height: 64px;">
          <span class="title">导入车辆发生错误</span>
        </v-card-title>
        <v-card-text style="min-height: 350px; max-height: 500px">
          <div class="mb-4" v-if="importErrorDialog.duplicates.length > 0">
            <div class="subheading py-2">以下人员已在导入列表中</div>
            <!--<v-divider></v-divider>-->
            <l-data-table
              :headers="header"
              :init-pagination="{rowsPerPage: 5 ,sortBy: 'id', descending: false}"
              :items="importErrorDialog.duplicates"
              auto-actions
              flat
              hide-headers
              hide-title
            ></l-data-table>
          </div>
          <div v-if="importErrorDialog.vehicles.length > 0">
            <div class="py-2">
              <div class="subheading">以下人员信息正确，等待导入</div>
              <div class="py-1" v-if="importErrorDialog.haveDuplicatePlate">
                <span class="error--text caption">您导入的模板中含有重复的人员，导入时将以重复数据的第一条为准</span>
              </div>
            </div>
            <!--<v-divider></v-divider>-->
            <l-data-table
              :headers="header"
              :init-pagination="{rowsPerPage: 5 ,sortBy: 'id', descending: false}"
              :items="importErrorDialog.vehicles"
              auto-actions
              flat
              hide-headers
              hide-title
            ></l-data-table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="importTeacher(0)" color="grey" flat large>取消导入</v-btn>
          <v-btn :disabled="importErrorDialog.vehicles.length === 0"
                 @click="importTeacher(importErrorDialog.vehicles)"
                 color="error" flat large>仍然导入
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </l-layout>
</template>

<script>
  import {time} from "../../../ladmin/utils/time";
  import XLSX from 'xlsx'
  import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";

  export default {
    name: "applyForm_wx",
    components: {LDataTable},
    data(){
      return {
        select:[
          {value:'4',label:'行政办公类'},
          {value:'1',label:'科学研究类'},
          {value:'2',label:'本科生教学类'},
          {value:'3',label:'研究生教学类'},
        ],
        form:{
          park:'',
          parkName:'',
          controller:[],
          controllerName:'',
          controllerList:[],
          comment:"",
          referPlace:"",
          orgName:'',
          orgId:'',
          stTime:'',
          edTime:'',
          reviewType: ''
        },
        loading:false,
        disabledFlag:false,
        importList:[],
        importFlag:false,
        confirmDialog: {
          activated:false,
          hint:''
        },
        importFileProps: {
          activate: true,
          autoClose: true,
          title: '批量导入行人',
        },
        importFileRules: [
          v => !(!v || v.length === 0) || '必选',
          v => !v.some(f => !/\.xlsx$/i.test(f.name)) || '仅支持Excel表格(.xlsx)格式',
        ],
        importErrorDialog: {
          activate: false,
          vehicles: [],
          fails: [],
          duplicates: [],
          haveDuplicatePlate: false,
        },
        header:[
          {text:'教工编号',value:'loginId',sortable:false,align:'left'},
          {text:'教工姓名',value:'name',sortable:false,align:'left'},
          {text:'人员属性',value:'userType',sortable:false,align:'left'},
          {text:'单位编码',value:'orgId',sortable:false,align:'left'},
          {text:'单位名称',value:'orgName',sortable:false,align:'left'},
          {text:'轮班开始日期',value:'stTime',sortable:false,align:'true'},
          {text:'轮班截止日期',value:'edTime',sortable:false,align:'left'},
          {text:'备注',value:'remark',sortable:false,align:'left'},
        ]
      }
    },
    computed:{
      parkList(){
        let arr = this.$store.state.parkingLot.parkingLotList
        //console.log(arr)
        return arr
      },
      controllerList(){
        let arr = this.$store.state.parkingLot.unDirControllerList
        console.log(arr)
        return arr
      },
      curOrg(){
        let curOrg = this.$store.state.login.currentOrg
        return curOrg === undefined?{}:curOrg
      },
      hasFirstReviewPermission(){
        let permission = this.$store.state.login.permission
        if(permission.wechat!==undefined&&permission.wechat.firstAudit!==undefined){
          return true
        }else{
          return false
        }
      },
      hasSecondReviewPermission(){
        let permission = this.$store.state.login.permission
        if(permission.wechat!==undefined&&permission.wechat.secondAudit!==undefined){
          return true
        }else{
          return false
        }
      },
    },
    watch:{
      'form.park'(){
        this.form.controllerList = []
        //console.log(this.controllerList)
        for(let i=0;i<this.controllerList.length;i++){
          if(this.controllerList[i].park[0].id === this.form.park){
            this.form.controllerList.push(this.controllerList[i])
          }
        }
        this.form.parkName = ''
        for(let i=0;i<this.parkList.length;i++){
          if(this.parkList[i].id === this.form.park){
            this.form.parkName = this.parkList[i].name
            break
          }
        }
      },
    },
    async created(){
      this.form.stTime = this.getDay()
      await this.$store.dispatch('login/initSystemInfo', false)
    },
    methods:{
      confirm(){
        if(this.$refs.form.validate()){
          this.form.stTime = this.getDay()
          this.form.edTime = this.getDay()
          this.form.orgName = this.curOrg.name === undefined?'':this.curOrg.name
          this.form.orgId = this.curOrg.id === undefined?'':this.curOrg.id
          this.confirmDialog.activated = true
        }else{
          this.$L.alert('error',{message:'表单数据错误'})
        }
      },
      async submit(){
        let params = {
          "tempAuditReq":[{
            "orgId":this.form.orgId,
            "orgName":this.form.orgName,
            "comment":this.form.comment,
            "referPlace":this.form.referPlace,
            "stTime":this.form.stTime,
            "edTime":this.form.edTime,
            "reviewType":this.form.reviewType
          }]
        }
        try {
          this.loading=true
          let res = await this.$store.dispatch('school/apply',params)
          if(res.data.status === 1){
            this.disabledFlag = true
            this.confirmDialog.activated = false
            this.$L.alert('success',{message:'申请成功'})
          }else{
            this.$L.alert('error',{message:"申请失败，原因:"+res.data.msg})
          }
        }catch (e) {

        }finally {
          this.loading = false
        }
      },
      async importTeacherSubmit(){
        let arr = []
        for(let i=0;i<this.importList.length;i++){
          let t = this.importList[i]
          let obj = {
            "orgName":this.curOrg.name,
            "name":t.name,
            "loginId":t.loginId,
            "remark":t.remark,
            "orgId":t.orgId,
            "comment":t.comment,
            "stTime":t.stTime,
            "edTime":t.edTime,
            "userType":t.userType
          }
          arr.push(obj)
        }
        let params = {
          "tempAuditReq":arr
        }
        try {
          this.loading = true
          let res = await this.$store.dispatch('school/importTeachers',params)
          if(res.data.status === 1){
            this.$L.alert('success',{message:'申请成功'})
            this.disabledFlag = true
          }else{
            this.$L.alert('error',{message:"申请失败，原因:"+res.data.msg})
          }
        }catch (e) {

        }finally {
          this.loading = false
        }
      },
      getDay(){
        let d = new Date()
        let nd = new Date().setDate(d.getDate()+1)
        let str = time.stringify(nd).substring(0,10)
        return str
      },
      goApplyList(){
        this.$router.push({name:'selfApplyList_wx'})
      },
      goFirstReviewList(){
        this.$router.push({name:'firstReviewList_wx'})
      },
      goSecondReviewList(){
        this.$router.push({name:'secondReviewList_wx'})
      }
    }
  }
</script>

<style scoped>

</style>
